import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostDateiArtCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostDateiArtCommandService],
  exports: []
})
export class PostDateiArtCommandServiceModule { }
